interface AccentMarkProps {
  size?: number;
  type?: 'x' | 'plus' | 'dot' | 'hash';
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  className?: string;
}

export function AccentMark({
  size = 20,
  type = 'x',
  color = 'secondary',
  opacity = 0.50,
  className = ''
}: AccentMarkProps) {
  const colorMap: Record<string, string> = {
    primary: 'var(--color-primary-500)',
    secondary: 'var(--color-secondary-500)',
    accent: '#10B981',
    neutral: '#64748b',
  };

  const renderMark = () => {
    switch (type) {
      case 'x':
        return (
          <>
            <line
              x1={size * 0.2}
              y1={size * 0.2}
              x2={size * 0.8}
              y2={size * 0.8}
              stroke={colorMap[color]}
              strokeWidth={2.5}
              strokeLinecap="round"
            />
            <line
              x1={size * 0.8}
              y1={size * 0.2}
              x2={size * 0.2}
              y2={size * 0.8}
              stroke={colorMap[color]}
              strokeWidth={2.5}
              strokeLinecap="round"
            />
          </>
        );
      case 'plus':
        return (
          <>
            <line
              x1={size * 0.5}
              y1={size * 0.15}
              x2={size * 0.5}
              y2={size * 0.85}
              stroke={colorMap[color]}
              strokeWidth={2.5}
              strokeLinecap="round"
            />
            <line
              x1={size * 0.15}
              y1={size * 0.5}
              x2={size * 0.85}
              y2={size * 0.5}
              stroke={colorMap[color]}
              strokeWidth={2.5}
              strokeLinecap="round"
            />
          </>
        );
      case 'dot':
        return (
          <circle
            cx={size * 0.5}
            cy={size * 0.5}
            r={size * 0.22}
            fill={colorMap[color]}
          />
        );
      case 'hash':
        return (
          <>
            <line x1={size * 0.35} y1={size * 0.15} x2={size * 0.25} y2={size * 0.85} stroke={colorMap[color]} strokeWidth={2} strokeLinecap="round" />
            <line x1={size * 0.75} y1={size * 0.15} x2={size * 0.65} y2={size * 0.85} stroke={colorMap[color]} strokeWidth={2} strokeLinecap="round" />
            <line x1={size * 0.12} y1={size * 0.38} x2={size * 0.88} y2={size * 0.38} stroke={colorMap[color]} strokeWidth={2} strokeLinecap="round" />
            <line x1={size * 0.12} y1={size * 0.62} x2={size * 0.88} y2={size * 0.62} stroke={colorMap[color]} strokeWidth={2} strokeLinecap="round" />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      className={className}
      style={{ opacity }}
    >
      {renderMark()}
    </svg>
  );
}
